import { Box } from '@chakra-ui/react';
import { useLocation } from 'react-router';
import type { PageFC } from '@salesforce/pwa-kit-react-sdk';
import { Layout } from '../../../components/layout/Layout';
import { Blocks } from '../../../components/sfcc-content-rendering/Blocks';
import { useBreadcrumbs } from '../../../ui-components/breadcrumbs/useBreadcrumbs';
import { canonicalUrlCleanup } from '../../../utils/canonical-url-cleanup';
import { BreadcrumbSchema } from '../../../utils/schema';
import { SearchHead } from '../../search/SearchHead';
import type { CategoryInfo } from '../api/getContentData';

type Props = {
    categoryInfo?: CategoryInfo;
};

const ShowCmsLanding: PageFC<Props> = ({ categoryInfo }: Props) => {
    const category = categoryInfo?.response?.category;
    const breadcrumbs = useBreadcrumbs(category?.parentCategoryTree);
    const location = useLocation();
    return (
        <Layout>
            <SearchHead canonicalUrl={canonicalUrlCleanup(location.pathname)} />
            <Box width="100%">
                <BreadcrumbSchema breadcrumbTrail={breadcrumbs} />
                <div className="shop-by-category">
                    <div className="pt_categorylanding">
                        <div className="cms-slots">
                            <div className="main-cms-banner-top">
                                <Blocks
                                    id="cms-page-slot-1"
                                    contentBlocks={
                                        categoryInfo?.response?.categoryContent?.categorySlots
                                    }
                                />
                            </div>
                        </div>
                        <div className="cms-section-main">
                            <div className="cms-section-one">
                                <Blocks
                                    id="cms-page-slot-2"
                                    contentBlocks={
                                        categoryInfo?.response?.categoryContent?.categorySlots
                                    }
                                />
                            </div>
                            <div className="cms-section-two">
                                <Blocks
                                    id="cms-page-slot-3"
                                    contentBlocks={
                                        categoryInfo?.response?.categoryContent?.categorySlots
                                    }
                                />
                            </div>
                            <div className="cms-marketing-text">
                                <Blocks
                                    id="cms-page-slot-4"
                                    contentBlocks={
                                        categoryInfo?.response?.categoryContent?.categorySlots
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Box>
        </Layout>
    );
};

ShowCmsLanding.defaultProps = {
    categoryInfo: undefined,
};

export { ShowCmsLanding };
